import { createAction } from '@reduxjs/toolkit';

export const setJumioCaller = createAction<
  { caller: string },
  'jumio/SET_JUMIOCALLER'
>('jumio/SET_JUMIOCALLER');
